var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun-search-875357",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.213,
    height: 21.244,
    viewBox: "0 0 21.213 21.244",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8457",
    "data-name": "Path 8457",
    d: "M208.526,137.008l-3.959-3.924a9.567,9.567,0,0,0-.707-12.69,9.535,9.535,0,0,0-13.467,13.5,9.53,9.53,0,0,0,12.69.707l3.924,3.924a1.018,1.018,0,0,0,.742.318.963.963,0,0,0,.742-.318,1.1,1.1,0,0,0,.035-1.52Zm-3.959-9.862a7.268,7.268,0,0,1-2.191,5.231,7.476,7.476,0,0,1-5.231,2.191,7.268,7.268,0,0,1-5.231-2.191,7.475,7.475,0,0,1-2.192-5.231,7.268,7.268,0,0,1,2.191-5.231,7.413,7.413,0,0,1,5.232-2.192,7.268,7.268,0,0,1,5.231,2.191A7.414,7.414,0,0,1,204.567,127.146Z",
    transform: "translate(-187.6 -117.602)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.c174cc53296ee8ae431512d3d8fc94fc.svg";
export { ForwardRef as ReactComponent };